import React, { FC } from 'react';

import useJoiValidation from '../hooks/useJoiValidation';
import { imageInteractiveComponentSchema } from './ImageInteractiveComponent.schema';
import { IImageInteractiveComponentProps } from './models';
import DangerouslySetInnerHtml from '../DangerouslySetInnerHtml';
import './style.scss';

const ImageInteractiveComponent: FC<IImageInteractiveComponentProps> = ({
    content,
}) => {
    const { data, }: { data: IImageInteractiveComponentProps; } = useJoiValidation(imageInteractiveComponentSchema, 'ImageinteractiveComponent', {
        content
    });


    return (
        <div className="cds-section cds-page-block cds-section--no-double-spacing">
     <DangerouslySetInnerHtml html={data.content} className='modal' />
            </div>
    );
};

export default ImageInteractiveComponent;
